import { i18n } from 'i18next';
import { PropsWithChildren, Suspense, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import { initializeI18n } from '@services/i18nService';
import { Environment, Locale, ShopBundle } from '@types-internal';

export type I18nProviderProps = {
  shopBundle: ShopBundle;
  locale: Locale;
  env: Environment;
};

export const I18nProvider: React.FC<PropsWithChildren<I18nProviderProps>> = ({
  shopBundle,
  locale,
  env,
  children,
}) => {
  const [i18nInstance, setI18nInstance] = useState<i18n>();
  useEffect(() => {
    (async () => {
      const initializedI18n = await initializeI18n(shopBundle, locale, env);
      setI18nInstance(initializedI18n);
      initializedI18n.changeLanguage(locale);
    })();
  }, [shopBundle, locale, env]);
  if (!i18nInstance) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>
    </Suspense>
  );
};

export default I18nProvider;
